/* istanbul ignore next */
function saveVehicleService($http,
                            $location,
                            $window,
                            $q,
                            alsService,
                            listingService,
                            modalService,
                            myAlertsService,
                            userSummaryService,
                            localStorageService,
                            pageStateService) {
    const getVehicleEndpoint = '/ajax/listingsapi/1.0/saved-vehicles',
        removeVehicleEndpoint = '/ajax/listingsapi/1.0/vehicle/listing',
        saveVehicleEndpoint = '/ajax/listingsapi/1.0/saved-vehicles';

    let email,
        featureId = '',
        initSaveState,
        listing,
        listingCalled,
        saveState,
        isRequiredLogin;

    return {
        decrementVehicleCount,
        deleteVehicle,
        forceSignup,
        getFeatureId,
        initializeListing,
        getVdpUrl,
        storeInitialVehicleStatus,
        isVehicleInitiallySaved,
        isVehicleSaved,
        incrementVehicleCount,
        mapListingObjectForCps,
        myAlertsCreateTracker,
        myAlertsRemoveTracker,
        okToSave,
        saveVehicle,
        sendAlsImpression,
        sendDtmTracking,
        getListing,
        getEmail,
        setEmail
    };


    //////////////////////////////////////////////////////////////////////////

    function initializeListing(requiredLogin) {
        isRequiredLogin = requiredLogin || false;
        if (!listingCalled || !listing) {
            listingCalled = true;
            myAlertsService.initializeService();
            userSummaryService.ready().then((summary) => {
                email = summary.getEmail();
            });
            return listingService.getListing().then((data) => {
                if (data.listingDetailDto) {
                    listing = mapListingObjectForCps(data.listingDetailDto);
                    storeInitialVehicleStatus();
                    return listing;
                }
            });
        } else { return $q.when(listing); }
    }

    function mapListingObjectForCps(listing) {
        return {
            listingId: listing.listingId,
            mdId: listing.modelId,
            mdNm: listing.modelName,
            mkId: listing.makeId,
            mkNm: listing.makeName,
            modelYear: listing.modelYear,
            modelYearId: listing.modelYearId,
            stkTyp: (listing.isNewCarStockType) ? "New" : "Used",
            trimId: listing.trimId,
            trimName: listing.trimName,
            state: listing.state,
            zipcode: listing.zipcode,
            sellerId: listing.sellerId,
            stockTypeCode: listing.stockTypeCode,
            price: listing.price,
            cpo: listing.cpoVehicle,
            bodyStyle: listing.bodystyleName,
            customerId: listing.customerId,
            dealerName: listing.dealerName,
            url: getVdpUrl(listing.listingId)
        };
    }

    function storeInitialVehicleStatus() {
        let parsedPath;
        return $http.get(getVehicleEndpoint + '/' + listing.listingId, {withCredentials: true}).then((response) => {
            initSaveState = response.data.foundListing;
            saveState = initSaveState;
            if (response.data && response.data.unsavePath) {
                parsedPath = response.data.unsavePath.split('/');
                featureId = parsedPath[parsedPath.length - 1];
            }
        });
    }

    function sendAlsImpression() {
        if (!listing) {
            return;
        }
        let alsObj = {
            "listingId": listing.listingId ? listing.listingId : "",
            "modelYearId": listing.modelYearId ? listing.modelYearId : "",
            "makeId": listing.mkId ? listing.mkId : "",
            "modelId": listing.mdId ? listing.mdId : "",
            "trimId": listing.trimId ? listing.trimId : "",
            pageToId: 2238,
            "stockTypeCode": listing.stockTypeCode ? listing.stockTypeCode : "",
            "sellerId": listing.sellerId ? listing.sellerId : "",
        };
        alsService.impression(alsObj);
    }

    function sendDtmTracking() {
        if (!listing) {
            return;
        }
        let dtmObj = {
            bodystyleName: listing.bodyStyle,
            category: 'saveVehicle',
            name: "save-vehicle",
            location: "vdp",
            cpo: listing.cpo,
            customerId: listing.customerId,
            dealer: listing.dealerName,
            listingId: listing.listingId,
            makeName: listing.mkNm,
            modelName: listing.mdNm,
            modelYear: listing.modelYear,
            price: listing.price,
            stockType: listing.stockTypeCode,
        };
        pageStateService.push('page.lead', dtmObj, false);
    }

    function forceSignup() {
        try {
            localStorageService.setItem('listingToSaveAfterLoginOrSignup', listing.listingId);
            $window.location = '/profile/secure/signup/?continue=' + encodeURIComponent($location.path());
        } catch (err) {
            // ignore error
        }
    }

    function myAlertsCreateTracker() {
        if (email) {
            myAlertsService.createTracker(email, listing);
        } else {
            userSummaryService.onRefresh((summary) => {
                email = summary.getEmail();
                if (isVehicleSaved()) {
                    if (email && listing) {
                        myAlertsService.createTracker(email, listing);
                    } else if (!myAlertsService.getOptoutState()) {
                        modalService.get('myAlertsModal').open();
                    }
                }
            });
            userSummaryService.refresh();
        }
    }

    function myAlertsRemoveTracker() {
        if (email && listing && listing.url) {
            myAlertsService.removeTracker(email, listing.url);
        } else {
            userSummaryService.onRefresh((summary) => {
                email = summary.getEmail();
                if (!isVehicleSaved()) {
                    if (email && listing && listing.url) {
                        myAlertsService.removeTracker(email, listing.url);
                    }
                }
            });
            userSummaryService.refresh();
        }
    }

    function okToSave() {
        if (!isRequiredLogin) {
            return true;
        }
        return $window.document.cookie.indexOf('rememberMe') > -1;
    }

    function saveVehicle() {
        var postValues = {},
            postKeys = [
                'listingId', 'modelYear', 'mkNm', 'mdNm', 'trimName',
                'stkTyp', 'modelYearId', 'mkId', 'mdId', 'trimId'
            ];

        angular.forEach(postKeys, function (i) {
            postValues[i] = listing[i];
        });

        return $http.post(saveVehicleEndpoint, postValues, {withCredentials: true})
            .then((response) => {
                initSaveState = false;
                saveState = true;
                featureId = response.data.featureId;
                incrementVehicleCount();
                modalService.get('myAlertsModal').open();
                sendAlsImpression();
                sendDtmTracking();
            });

    }

    function deleteVehicle() {
        if (featureId) {
            return $http.delete(removeVehicleEndpoint + '/' + featureId, {withCredentials: true})
                .then(() => {
                    featureId = '';
                    initSaveState = false;
                    saveState = false;
                    decrementVehicleCount();
                    myAlertsRemoveTracker(listing.listingId);
                });
        } else { return $q.resolve(); }
    }

    function getVdpUrl(listingId) {
        if (listingId) {
            const host = $location.host();
            const protocol = ($location.absUrl().substr(0, 5) === 'https') ? 'https' : 'http';
            const url = `${protocol}://${host}/vehicledetail/detail/${listingId}/overview`;
            return url;
        }
        return '';
    }

    function getEmail() {
        return email;
    }

    function setEmail(myEmail) {
        if (myEmail) {
            email = myEmail;
        }
    }

    function incrementVehicleCount() {
        return userSummaryService.ready()
            .then((summary) => {
                summary.incrementSavedCarCount();
                ($window.profiles) ? $window.profiles.publish("profile.add.car", {favorites: { cars: summary.getSavedCarCount() }}) : '';
            });
    }

    function decrementVehicleCount() {
        return userSummaryService.ready()
            .then((summary) => {
            summary.decrementSavedCarCount();
            ($window.profiles) ? $window.profiles.publish("profile.remove.car", {favorites: { cars: summary.getSavedCarCount() }}) : "";
        });
    }

    function getListing() {
        return listing;
    }

    function getFeatureId() {
        return featureId;
    }

    function isVehicleSaved() {
        return saveState && !!featureId;
    }

    function isVehicleInitiallySaved() {
        return initSaveState;
    }

}

saveVehicleService.$inject = [
    /* your service dependencies should go here */
    "$http",
    "$location",
    "$window",
    "$q",
    "alsService",
    "listingService",
    "modalService",
    "myAlertsService",
    "userSummaryService",
    "localStorageService",
    "pageStateService",
];
export default saveVehicleService;
